// extracted by mini-css-extract-plugin
export var container = "_dh-0";
export var content = "_dh-3";
export var customerTitle = "_dh-4";
export var empty = "_dh-5";
export var gray = "_dh-6";
export var header = "_dh-7";
export var info = "_dh-8";
export var loading = "_dh-2";
export var loadingCard = "_dh-9";
export var oneLine = "_dh-a";
export var personName = "_dh-e";
export var pillContainer = "_dh-b";
export var selected = "_dh-1";
export var text = "_dh-c";
export var twoLines = "_dh-d";
export var unread = "_dh-f";
export var unreadIndicator = "_dh-g";